import type { NotificationUnreadCount, NotificationView } from '@chukua/common';
import { api } from '../../shared/shared.api';

export function listNotifications(limit: number): Promise<NotificationView[]> {
  return api<NotificationView[]>(`/notifications?limit=${limit}`);
}

export async function getUnreadNotificationCount(): Promise<number> {
  return (await api<NotificationUnreadCount>('/notifications/unread-count')).unread;
}

export async function markNotificationRead(id: string): Promise<void> {
  await api<void>(`/notifications/${id}/read`, { method: 'PATCH' });
}
